(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel-multi"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.hero-carousel__track');
      this.slides = Array.from(container.querySelectorAll('.hero-carousel__slide'));
      this.dots = Array.from(container.querySelectorAll('.hero-carousel__dot'));
      this.prevBtn = container.querySelector('.hero-carousel__arrow--prev');
      this.nextBtn = container.querySelector('.hero-carousel__arrow--next');

      if (this.slides.length <= 1) return;

      this.currentIndex = 0;
      this.slideCount = this.slides.length;
      this.isTransitioning = false;

      // Settings from data attributes
      this.autoplay = container.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 5000;
      this.transitionStyle = container.dataset.transitionStyle || 'fade';
      this.transitionDuration = parseInt(container.dataset.transitionDuration, 10) || 500;
      this.pauseOnHover = container.dataset.pauseOnHover === 'true';

      this.autoplayInterval = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.touchMoved = false;
      this.ignoreTouch = false;
      this.minSwipeDistance = 50;

      this.init();
    }

    init() {
      this.bindEvents();
      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    bindEvents() {
      // Arrow navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch events for mobile swipe
      this.container.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.container.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
      this.container.addEventListener('touchend', () => this.handleTouchEnd());

      // Pause on hover
      if (this.pauseOnHover && this.autoplay) {
        this.container.addEventListener('mouseenter', () => this.stopAutoplay());
        this.container.addEventListener('mouseleave', () => this.startAutoplay());
      }

      // Keyboard navigation
      this.container.addEventListener('keydown', (e) => this.handleKeydown(e));

      // Handle visibility change to pause/resume autoplay
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else if (this.autoplay) {
          this.startAutoplay();
        }
      });
    }

    handleTouchStart(e) {
      const touch = e.changedTouches[0];
      this.touchStartX = touch.screenX;
      this.touchStartY = touch.screenY;
      // Reset the end point, otherwise a plain tap is measured against the last
      // position of a previous gesture and reads as a swipe.
      this.touchEndX = this.touchStartX;
      this.touchEndY = this.touchStartY;
      this.touchMoved = false;

      // A touch that starts on a link or button is a tap, never a swipe.
      this.ignoreTouch = !!(e.target.closest && e.target.closest('a, button'));

      // Hold the slide still while the finger is down so autoplay can't advance
      // out from under the tap.
      this.stopAutoplay();
    }

    handleTouchMove(e) {
      const touch = e.changedTouches[0];
      this.touchEndX = touch.screenX;
      this.touchEndY = touch.screenY;
      this.touchMoved = true;
    }

    handleTouchEnd() {
      const diffX = this.touchStartX - this.touchEndX;
      const diffY = this.touchStartY - this.touchEndY;

      if (
        this.touchMoved &&
        !this.ignoreTouch &&
        Math.abs(diffX) >= this.minSwipeDistance &&
        Math.abs(diffX) > Math.abs(diffY)
      ) {
        if (diffX > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else if (this.autoplay) {
        this.startAutoplay();
      }
    }

    handleKeydown(e) {
      if (e.key === 'ArrowLeft') {
        this.prev();
      } else if (e.key === 'ArrowRight') {
        this.next();
      }
    }

    goToSlide(index) {
      if (this.isTransitioning || index === this.currentIndex) return;

      this.isTransitioning = true;
      const prevIndex = this.currentIndex;

      // Handle slide transition style
      if (this.transitionStyle === 'slide') {
        this.slides[prevIndex].classList.add('hero-carousel__slide--prev');
      }

      // Remove active class from current slide and dot
      this.slides[this.currentIndex].classList.remove('hero-carousel__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('hero-carousel__dot--active');
      }

      // Update current index
      this.currentIndex = index;

      // Add active class to new slide and dot
      this.slides[this.currentIndex].classList.add('hero-carousel__slide--active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('hero-carousel__dot--active');
      }

      // Update navigation color scheme based on current slide
      this.updateNavigationColorScheme();

      // Reset transition state after animation
      setTimeout(() => {
        this.isTransitioning = false;
        if (this.transitionStyle === 'slide') {
          this.slides[prevIndex].classList.remove('hero-carousel__slide--prev');
        }
      }, this.transitionDuration);

      // Reset autoplay timer
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    updateNavigationColorScheme() {
      const newColorScheme = this.slides[this.currentIndex].dataset.colorScheme;
      if (newColorScheme) {
        const arrowsContainer = this.container.querySelector('.hero-carousel__arrows');
        const dotsContainer = this.container.querySelector('.hero-carousel__dots');
        
        if (arrowsContainer) {
          // Remove old color scheme classes
          arrowsContainer.className = arrowsContainer.className.replace(/color-\S+/g, '').trim();
          arrowsContainer.classList.add(newColorScheme);
        }
        if (dotsContainer) {
          // Remove old color scheme classes
          dotsContainer.className = dotsContainer.className.replace(/color-\S+/g, '').trim();
          dotsContainer.classList.add(newColorScheme);
        }
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slideCount;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        this.next();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  // Initialize all carousels on the page
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hero-carousel').forEach((carousel) => {
      new HeroCarousel(carousel);
    });
  });

  // Re-initialize on Shopify section events (for theme editor)
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('.hero-carousel');
      if (carousel) {
        new HeroCarousel(carousel);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
